<template>
  <div>
    <b-modal ref="my-modal" centered hide-footer :title="'Edit Access'">
      <form v-on:submit.prevent="doEditAccess">
        <label class="labels">Name *</label>
        <b-form-input :required="true" for-input="name" type="text" name="name" id="name" label="Bill Number" placeholder="Enter Name" v-validate="modelValidations.name" :error="errors.first('name')" v-model="model.name" data-vv-as="name"/><br>
        <label class="labels">Role *</label>
        <div class="form-group" :required="true" v-bind:class="errors.has('role') ? 'has-error':''">
          <b-form-select name="role" v-model="model.role" v-validate="modelValidations.role" v-bind:class="errors.has('role') ? 'is-invalid':''" :error="errors.first('role')" :options="roleList">
          </b-form-select>
        </div>
        <b-button variant="warning" class="mt-3 btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> Update </b-button>
        <b-button variant="secondary" class="mt-3 float-left" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
      </form>
    </b-modal>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        isLoading: false,
        apiUrl: {
          profile: window.AppConfig.apiUrl + 'profile?limit=100',
        },
        model: {
          uuid: null,
          name: null,
          role: null
        },
        roleList: [
          {
            value: 'Supervisor',
            text: 'Supervisor'
          },
          {
            value: 'Manager',
            text: 'Manager'
          },
          {
            value: 'Transportation',
            text: 'Transportation'
          },
          {
            value: 'Admin',
            text: 'Admin'
          },
          {
            value: 'User',
            text: 'User'
          }
        ],
        modelValidations: {
          name: {
            required: true
          },
          role: {
            required: true
          }
        }
      }
    },
    mounted() {
      this.getEmployee()
    },
    methods: {
      doEditAccess() {
        this.$validator.validateAll().then(res => {
          if (res) {
            this.isLoading = true

            let formData = new FormData()
            formData.append('name', this.model.name)
            formData.append('role', this.model.role)
            if (this.model.uuid !== null) {
              let model = {}
              Object.keys(this.model).forEach(element => {
                if (element !== 'uuid') {
                  model[element] = this.model[element]
                }
              })
              this.$http.patch(this.apiUrl.role + '/' + this.model.uuid, formData).then(response => {
                this.isLoading = false
                this.$store.dispatch('notification/success', 'Access data successfully updated.')
                this.hideModal()
                this.resetData()
                this.$emit('getAccess')
              }).catch(error => {
                this.isLoading = false
                this.$store.dispatch('notification/error', error)
              })
            }
          }
        })
      },
      resetData () {
        this.model.uuid = null
        this.model.name = null
        this.model.role = null
        this.$validator.reset()
      },
      showModal(row) {
        this.model.uuid = row.uuid
        this.model.name = row.firstName + '\xa0' + row.lastName
        this.model.role = row.role
        this.$validator.reset();
        this.$refs['my-modal'].show()
      },
      hideModal () {
        this.resetData()
        this.$refs['my-modal'].hide()
      },
      getDate (value) {
        if (value !== null) {
          return this.$moment(value).format('YYYY-MM-DD')
        } else {
          return '-'
        }
      },
      getEmployee () {
        this.$http.get(window.AppConfig.apiUrl + 'profile?limit=100').then(response => {
          response.data._embedded.profile.forEach(data => {
            this.roleList.push({
              value: data.uuid,
              text: data.name
            })
          })
        })
      }
    }
  }
</script>